import CustomLoading from '@/components/custom-loading';
import CustomLottie from '@/components/custom-lottie';

const PaymentProcessing = () => {
  return (
    <div className="flex h-full flex-col items-center justify-center bg-white">
      <CustomLottie
        path="/images/lotties/payment-processing.json"
        className="h-[281px] w-[445px]"
        loop={true}
      />
      <CustomLoading />
      <p className="text-5xl font-bold">PROCESSING</p>
    </div>
  );
};

export default PaymentProcessing;
